import React from 'react';

const AnimatingDot = () => {
  return (
    <span className="inline-block w-4 h-4 bg-blue-500 rounded-full animate-pulse"></span>
  );
};

export default AnimatingDot;
